<template>
  <div id="app" class="app-wrapper">
    <div class="main-content">
      <Header />
      <PasswordGen />
      <CreditsConsole />
    </div>
    <Footer />
    <Toaster position="top-center" />
  </div>
</template>

<script>
import PasswordGen from './components/PasswordGenerator.vue'
import Header from './components/HeaderApp.vue'
import Footer from './components/FooterApp.vue'
import CreditsConsole from './components/CreditsConsoleLog.vue'
import { Toaster } from '@/components/ui/sonner'

export default {
  name: 'App',
  components: {
    PasswordGen,
    Header,
    Footer,
    CreditsConsole,
    Toaster
  }
}
</script>

<style>
#app.app-wrapper {
  font-family: system-ui, -apple-system, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  padding-top: 2rem;
  padding-bottom: 5rem;
}

.app-wrapper .main-content {
  flex: 1;
  max-width: 42rem;
  margin-left: auto;
  margin-right: auto;
  width: 100%;
  padding-left: 1rem;
  padding-right: 1rem;
}
</style>
